/**
 * Klik Muebles – Boleta/Factura obligatorio + RUT válido (v5, sólo página del carrito)
 *
 * - Sólo actúa en /cart. En cualquier otra página no hace nada.
 * - Deja los radios "Boleta" y "Factura" desmarcados al cargar.
 * - Autoformatea el RUT mientras se escribe: sin puntos y con guion (12345678-5).
 * - Valida el RUT por nuestro lado (formato + dígito verificador, módulo 11).
 *   Sólo se exige cuando el campo RUT está visible (es decir, con Factura);
 *   con Boleta el campo no se muestra y no se valida nada.
 * - Bloquea únicamente el botón "Ir a pagar" del carrito (#checkout-submit /
 *   botón name="checkout" del form#cart) mientras:
 *     1) no se haya elegido Boleta o Factura, o
 *     2) el RUT visible esté vacío o sea inválido.
 * - No intercepta navegación global, links, drawer ni botones de pago express.
 * - No envía ni modifica datos (sin fetch/XHR, cookies ni storage).
 *
 * Los listeners van en `window` (fase captura) para correr antes que los
 * listeners de la app Melo en `document`; así el spam de clics no se los salta
 * y la app lee el RUT ya formateado.
 */
(function () {
  'use strict';
  if (!/^\/cart\/?$/.test(location.pathname)) return; // sólo en /cart
  if (window.__kkDocTypeGuard) return;                // evita doble instalación
  window.__kkDocTypeGuard = true;

  var RADIO_SEL = 'input[type="radio"][name^="melo-billing-doc-type"]';
  var WIDGET_SEL = '.melo-billing-doc-widget';
  var RUT_SEL = '#boleta-factura-input-rut';
  var ERROR_CLASS = 'kk-doc-type-error';
  var RUT_ERROR_CLASS = 'kk-rut-error';
  var ERROR_STYLE = 'color:#d72c0d;font-size:13px;margin:-4px 0 10px;';
  var MSG = 'Debes seleccionar si quieres Boleta o Factura antes de continuar.';
  var MSG_RUT_EMPTY = 'Ingresa el RUT para la factura.';
  var MSG_RUT_INVALID = 'El RUT ingresado no es válido. Revisa el número y el dígito verificador.';

  var userChose = false;

  /* ───────────── Utilidades ───────────── */

  function radios() {
    return Array.prototype.slice.call(document.querySelectorAll(RADIO_SEL));
  }
  function inViewport(el) {
    var r = el.getBoundingClientRect();
    return r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
  }
  function scrollToIfNeeded(el) {
    if (el && !inViewport(el)) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  // ¿Es el botón "Ir a pagar" del carrito?
  function isCartCheckoutButton(el) {
    if (!el) return false;
    if (el.id === 'checkout-submit') return true;
    return el.name === 'checkout' &&
      (el.getAttribute('form') === 'cart' || !!el.closest('form#cart'));
  }

  /* ───────────── Boleta / Factura ───────────── */

  function mustBlockDocType() {
    return !userChose && radios().length > 0;
  }
  function uncheckAll() {
    if (userChose) return;
    radios().forEach(function (r) { r.checked = false; });
  }
  function clearDocErrors() {
    document.querySelectorAll('.' + ERROR_CLASS).forEach(function (e) { e.remove(); });
  }
  function showDocErrors() {
    clearDocErrors();
    var target = null;
    document.querySelectorAll(WIDGET_SEL).forEach(function (w) {
      var box = w.querySelector('.melo-billing-doc-widget__radios') || w;
      var err = document.createElement('div');
      err.className = ERROR_CLASS;
      err.setAttribute('role', 'alert');
      err.textContent = MSG;
      err.style.cssText = ERROR_STYLE;
      box.insertAdjacentElement('afterend', err);
      if (!target && w.offsetParent !== null) target = w;
    });
    scrollToIfNeeded(target);
  }

  /* ───────────── RUT: formato y validación ───────────── */

  var nativeSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;

  // Texto formateado: hasta 8 dígitos + guion + dígito verificador (0-9 o K).
  function formatRut(raw) {
    var clean = raw.replace(/[^0-9kK]/g, '').toUpperCase().slice(0, 9);
    if (!clean) return '';
    var dv = clean.slice(-1);
    var body = clean.slice(0, -1).replace(/K/g, ''); // la K sólo es válida al final
    if (!body) return dv === 'K' ? '' : dv;
    return body + '-' + dv;
  }

  // Dígito verificador esperado (módulo 11, multiplicadores 2..7 de derecha a izquierda).
  function expectedDv(body) {
    var sum = 0, mul = 2;
    for (var i = body.length - 1; i >= 0; i--) {
      sum += parseInt(body.charAt(i), 10) * mul;
      mul = mul === 7 ? 2 : mul + 1;
    }
    var r = 11 - (sum % 11);
    return r === 11 ? '0' : (r === 10 ? 'K' : String(r));
  }

  function isValidRut(text) {
    var m = /^(\d{7,8})-([\dK])$/.exec((text || '').trim().toUpperCase());
    return !!m && expectedDv(m[1]) === m[2];
  }

  // Campo RUT visible (el del drawer está oculto y comparte id, por eso se filtra por visibilidad).
  function visibleRutInput() {
    var list = document.querySelectorAll(RUT_SEL);
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) return list[i];
    }
    return null;
  }

  function clearRutErrors() {
    document.querySelectorAll('.' + RUT_ERROR_CLASS).forEach(function (e) { e.remove(); });
    document.querySelectorAll(RUT_SEL).forEach(function (i) {
      i.removeAttribute('aria-invalid');
      i.style.borderColor = '';
    });
  }
  function showRutError(input, message) {
    clearRutErrors();
    var err = document.createElement('div');
    err.className = RUT_ERROR_CLASS;
    err.setAttribute('role', 'alert');
    err.textContent = message;
    err.style.cssText = ERROR_STYLE;
    var holder = input.closest('.melo-billing-doc-widget__field') || input;
    holder.insertAdjacentElement('afterend', err);
    input.setAttribute('aria-invalid', 'true');
    input.style.borderColor = '#d72c0d';
  }
  // Devuelve el motivo de bloqueo del RUT, o null si está bien (o no aplica).
  function rutProblem() {
    var input = visibleRutInput();
    if (!input) return null; // Boleta: el campo no se muestra, no se valida
    var value = input.value.trim();
    if (!value) return { input: input, message: MSG_RUT_EMPTY };
    if (!isValidRut(value)) return { input: input, message: MSG_RUT_INVALID };
    return null;
  }

  /* ───────────── Bloqueo del botón "Ir a pagar" ───────────── */

  // Devuelve true si bloqueó la acción.
  function guard(e) {
    if (mustBlockDocType()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showDocErrors();
      return true;
    }
    var p = rutProblem();
    if (p) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showRutError(p.input, p.message);
      scrollToIfNeeded(p.input);
      try { p.input.focus({ preventScroll: true }); } catch (err) {}
      return true;
    }
    return false;
  }

  /* ───────────── Listeners ───────────── */

  // Autoformato mientras se escribe (+ re-validación en vivo si ya se mostró un error)
  window.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(RUT_SEL)) return;

    var formatted = formatRut(el.value);
    if (formatted !== el.value) {
      // Cuántos caracteres "útiles" (dígitos/K) hay antes del cursor
      var caret = el.selectionStart;
      var before = el.value.slice(0, caret).replace(/[^0-9kK]/g, '').length;

      nativeSetter.call(el, formatted); // compatible con inputs controlados (React/Vue)

      // Reposiciona el cursor, saltando el guion si corresponde
      var dash = formatted.indexOf('-');
      var pos = (dash !== -1 && before > dash) ? before + 1 : before;
      pos = Math.min(pos, formatted.length);
      try { el.setSelectionRange(pos, pos); } catch (err) {}
    }

    // Si había un error visible, se quita en cuanto el RUT queda válido
    if (document.querySelector('.' + RUT_ERROR_CLASS) && isValidRut(el.value)) clearRutErrors();
  }, true);

  // Al salir del campo: si escribió algo y es inválido, avisa de inmediato
  window.addEventListener('focusout', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(RUT_SEL)) return;
    var value = el.value.trim();
    if (!value) return;
    if (isValidRut(value)) clearRutErrors();
    else showRutError(el, MSG_RUT_INVALID);
  }, true);

  // Elección explícita del cliente
  window.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches(RADIO_SEL)) {
      userChose = true;
      clearDocErrors();
      clearRutErrors(); // al cambiar Boleta/Factura se limpian errores del RUT anterior
    }
  }, true);

  // Clic en "Ir a pagar" del carrito
  window.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('button, input[type="submit"]');
    if (isCartCheckoutButton(btn)) guard(e);
  }, true);

  // Envío del form#cart hacia el pago (p. ej. Enter en un campo)
  window.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'cart' && isCartCheckoutButton(e.submitter)) guard(e);
  }, true);

  // Desmarcar ahora y si el widget se (re)monta
  uncheckAll();
  new MutationObserver(uncheckAll)
    .observe(document.documentElement, { childList: true, subtree: true });
  [100, 500, 1000, 2000, 4000].forEach(function (ms) { setTimeout(uncheckAll, ms); });
})();